import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from 'redux-persist';
import { UtilityFunctions } from "../../../utils";

const initialState = {
    productInformation: {
        rowId: 0,
        productCode: '',
        data: {
            frameDate: '',
            frameRollCode: '',
            middleTraverseDate: '',
            middleTraverseRollCode: '',
            plainSupportDate: '',
            plainSupportRollCode: '',
            da1Date: '',
            da1RollCode: '',
            da2Date: '',
            da2RollCode: '',
            da3Date: '',
            da3RollCode: '',
            da4Date: '',
            da4RollCode: '',
            da5Date: '',
            da5RollCode: '',
            da6Date: '',
            da6RollCode: '',
        },
        hasBeenConfirmed: false,
    },
    workOrderForm: {
        workOrderId: 0,
        date: UtilityFunctions.formatDate(new Date().toLocaleString()),
        rows: [],
        confirmData: {
            qaTechnician: false,
            qaEngineer: false,
            name: ''
        },
        hasBeenEmailed: false,
    },
    workOrderForms: [],
};

const workOrderFormSlice = createSlice({
    name: 'workOrderForm',
    initialState,
    reducers: {
        setWorkOrderForm: (state, action) => {
            state.workOrderForms = action.payload;
        },
        setProductInformation: (state, action) => {
            state.productInformation.data = action.payload;
        },
        setProductCode: (state, action) => {
            state.productInformation.productCode = action.payload;
        },
        addProductInformation(state, action) {
            state.workOrderForm.rows.unshift(action.payload);
            state.productInformation = initialState.productInformation;
        },
        removeRow(state, action) {
            state.workOrderForm.rows = state.workOrderForm.rows.filter(row => row.rowId !== action.payload);
        },
        confirm(state, action) {
            const { name, surname, role } = action.payload
            state.workOrderForm.confirmData[role] = true;
            state.workOrderForm.confirmData.name = `${name} ${surname} `
        },
        setWorkOrderData(state, action) {
            state.workOrderForm[action.payload.label] = action.payload.value
        },
        clearWorkOrderForm: (state) => initialState,
        setWorkOrderCounter(state, action) {
            state.workOrderForm.workOrderId = parseInt(action.payload) + 1
        }

    },
    extraReducers: (builder) => {
        // todo: do we need this
        builder.addCase(PURGE, (state) => {
            return initialState
        });
    },
})

export const workOrderFormActions = workOrderFormSlice.actions;
export default workOrderFormSlice.reducer;